/****************************************************
 * Module Name:  approveModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, TextField, Button, Typography } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import logo from '../../images/pansuriya.jpg'

function ApproveModal({
  show,
  setShow,
  handleValidation,
  handleSave,
  stoneId,
  selectedFilledData,
  type,
}) {
  const [remark, setRemark] = useState("");
  const [showError, setShowError] = useState(false);

  const approveStoneData = () => {
    let fArray = [];
    stoneId.map((id) => fArray.push({ stoneid: id }));
    return fArray;
  };

  const saveHandler = () => {
    let data = {};
    if (type === "approve") {
      data = {
        stones: approveStoneData(),
        remark: remark,
      };
    } else if (type === "price") {
      data = selectedFilledData;
    } else if (type === "tag") {
      data = {
        stones: selectedFilledData,
      };
    }
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(data)) {
          //need to add labId here and in the parent component if need for validation
          handleSave(data);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(data);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            Approve stone validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;
            {type === "approve"
              ? "Approve Stones"
              : type === "price"
                ? "Add prices"
                : "Add Tags"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {type === "approve" ? (
            <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
              <Form.Label className="mt-2">Remark</Form.Label>
              <TextField
                id="outlined-multiline-static"
                label="Remark"
                multiline
                fullWidth
                rows={4}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </Box>
          ) : (
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              Are You sure you want to add {type} for these stones ?
            </Typography>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="contained"
            onClick={() => saveHandler()}
            type="Submit"
            sx={{ mr: 3 }}
          >
            {type === "approve" ? "Approve" : "Yes"}
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
          >
            {type === "approve" ? "Close" : "No"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ApproveModal;
